import { isSelf, UserModel, UserState } from "@/models/user";
import { message as toast, message, Modal, Button, Skeleton } from "antd";
import React, { useCallback, useContext, useEffect, useState, useMemo } from "react";
import { AppState, ModalsState } from "@/models";
import { getSubscription, followSubscription } from "@/api/sub";
import { Session } from "@/types/chat";
import { connect } from "dvajs";
import log from "loglevel";
import Icon, { ExclamationCircleOutlined } from "@/utils/antdIcon";
import * as _ from "lodash";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import Bus from "@/utils/bus";
import { EbookState, MangeExternalModalInfo } from "@/models/ebook";
import { FocusSDK, isFocusEnv } from "@/utils";
import useShareUserCard from "@/components/Modals/useShareUserCard";
import { openUserSelectionDefaultModal } from "@/utils/modals";
import { NetState } from "@/models/netStatus";
import ChatState from "@/types/chat/State";
import useCommListener from "@/hooks/useCommListener";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import "./index.less";

const logger = log.getLogger("OrgAcctModal");
interface Props {
  userData: UserModel;
  selectedSession: Session;
}
export interface contactRelation {
  friendship: number;
  relation: number;
  contactType: any;
  isEnableAddFriend: boolean;
  isOnlyScanAdd: boolean;
  isRemove: boolean;
}

type IProps = Readonly<Props & AppState & EbookState & ChatState>;

function OrgAcctModal(
  props: IProps & {
    modalsData?: ModalsState;
  } & NetState
) {
  const [infoLoaded, setInfoLoaded] = useState(false);
  const [orgAccountData, setOrgAccountData]: any = useState({});
  const { userData, modals, modalsData, currentEmployee } = props;
  const { orgAcctModal } = modalsData ? modalsData : modals;
  const { visible, subId, followCb } = orgAcctModal;
  const { t } = useTranslation("common");
  const history = useHistory();
  const location = useLocation();
  useCommListener("orgAccountModal", modals.orgAcctModal.visible);

  // const shareUserCard = useShareUserCard({ userData, currentEmployee });
  const { isHomePage } = useContext<GlobalContextConfig>(GlobalContext);

  useEffect(() => {
    if (!visible) {
      setInfoLoaded(false);
    } else {
      console.log("loading orgAcct data props:", props);
      loadOrgAcctData();
    }
  }, [visible]);
  const doFollowFunc = async (followed: any) => {
    const [_r, err] = await followSubscription({
      subId: subId as string,
      followed: followed
    });
    if (err) {
      message.error(err);
      return;
    }
    message.success(followed === 1 ? "关注成功" : "已取消关注");
    loadOrgAcctData();
    followCb?.();
  };
  const handleFollowOpt = _.debounce(() => {
    let followed = orgAccountData.isFollowing === 1 ? 0 : 1;
    if (!followed) {
      Modal.confirm({
        title: "取消关注？",
        icon: <ExclamationCircleOutlined />,
        content: "取消后，您将无法及时接收该组织号的内容",
        okText: "继续关注",
        cancelText: "仍然取消",
        // onOk: () => {},
        onCancel: () => {
          doFollowFunc(followed);
        }
      });
    } else {
      doFollowFunc(followed);
    }
  }, 500);

  const loadOrgAcctData = async () => {
    const [_r, err] = await getSubscription({ subId: subId });
    if (err) {
      message.error(err);
      closeCard();
      return;
    }
    setOrgAccountData(_r);
  };

  const closeCard = () => {
    Bus.emit("app:toggle-org-acct-modal:hide", {});
    setOrgAccountData({});
  };

  const handleShareCurrent = useCallback(() => {
    openUserSelectionDefaultModal(
      {
        title: "分享广播号"
      },
      async ({ data }, close) => {
        const result = data.result.filter((i) => !i.frozen);

        close();
      },
      userData
    );
  }, [userData]);

  // 进入组织号会话
  const handleLaunchSession = useCallback(() => {
    history.push(
      `/messages/s/${orgAccountData.subId}?app=${currentEmployee.app}&tid=${currentEmployee.teamId}&secret=false&type=${orgAccountData?.type}`
    );
    closeCard();
  }, [orgAccountData, currentEmployee]);
  return (
    <Modal
      visible={visible && orgAccountData.subId}
      closable
      onCancel={closeCard}
      centered
      bodyStyle={{
        padding: 0
      }}
      wrapClassName="me-org-acct-modal"
      mask={true}
      maskStyle={{
        backgroundColor: "transparent"
      }}
      footer={null}
      destroyOnClose
    >
      {/* <Skeleton active avatar /> */}
      <div className="me-org-acct-modal-header">
        <div className="base-info-part">
          {orgAccountData.avatar ? (
            <img className="org-acct-avatar avatar-mask" src={orgAccountData.avatar} />
          ) : (
            <div className="org-acct-avatar avatar-mask" />
          )}
          <div className="org-acct-name">{orgAccountData.name || "测试组织号名称"}</div>
        </div>
        <div className="org-acct-opts">
          {orgAccountData?.followDisplay !== 0 && (
            <Button
              className={`org-acct-opt-btn ${
                orgAccountData?.followDisplay === 3 ? "org-acct-opt-btn-gray" : ""
              }`}
              type={orgAccountData.isFollowing === 1 ? "default" : "primary"}
              // disabled={orgAccountData?.followDisplay === 3}
              onClick={
                orgAccountData?.followDisplay === 3
                  ? () => {
                      message.error("默认关注，不支持取消关注");
                    }
                  : handleFollowOpt
              }
            >
              {orgAccountData?.followDisplay === 2 || orgAccountData?.followDisplay === 3
                ? "已关注"
                : "关注"}
            </Button>
          )}
          <Button className="org-acct-opt-btn" type="default" onClick={handleLaunchSession}>
            进入会话
          </Button>
        </div>
      </div>
      <div className="me-org-acct-modal-content">
        <div className="sub-info-label">归属部门</div>
        <div className="sub-info-text">{orgAccountData.ownerDepartmentName || ""}</div>
        <div className="sub-info-label">简介</div>
        <div className="sub-info-text">{orgAccountData.brief || ""}</div>
      </div>
    </Modal>
  );
}

function mapStateToProps({
  user,
  app,
  chat,
  ebook,
  netStatus
}: {
  chat: ChatState;
  user: UserState;
  app: AppState;
  ebook: EbookState;
  netStatus: NetState;
}) {
  return {
    userData: user.userData.user,
    modals: app.modals,
    currentEmployee: chat.currentEmployee,
    selectedSession: chat.selectedSession,
    newPublicResult: netStatus.newPublicResult,
    newPrivateResult: netStatus.newPrivateResult,
    isMessageModule: chat.isMessageModule,
    manageExternalModal: ebook.manageExternalModal
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    openCreateContactModal(data: any) {
      dispatch({ type: "ebook/openCreateContactModal", payload: data });
    },
    setOpenAdministratorListModal(payload: boolean) {
      dispatch({ type: "ebook/setOpenAdministratorListModal", payload });
    },
    openCreateAddUserLabelNameModel(data: any) {
      dispatch({ type: "ebook/openCreateAddUserLabelNameModel", payload: data });
    },
    updateCurrentEmployee(payload: any) {
      dispatch({ type: "chat/updateCurrentEmployee", payload });
    },
    setManageExternalModal(payload: boolean) {
      dispatch({ type: "ebook/setManageExternalModal", payload });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OrgAcctModal);
